import type { FC } from 'react';

import type { OfferItem, OfferRewardItem } from '../type';

import { DiamondIcon } from './diamond-icon';
import MultipleItems from './multiple-items';
import { RewardIcon } from './reward-icon';
import SingleItem from './single-item';

export const Body: FC<{
  items: OfferItem[] | undefined;
  rewardItems?: OfferRewardItem[];
  vipPoints: number | undefined;
  isAggregate?: boolean;
  storeItemDescription?: string;
  onItemClick?: (id: string) => void;
  isSingleContent: boolean;
}> = ({
  items,
  vipPoints,
  rewardItems,
  isAggregate,
  onItemClick,
  storeItemDescription,
  isSingleContent,
}) => {
  return (
    <>
      <div className="from-yellow800 h-[2px] w-full bg-gradient-to-b to-[#996500]" />

      <div className="relative bg-center bg-no-repeat">
        {Boolean(vipPoints) && (
          <div className="font-poppins text-2xs relative leading-4">
            <div className="h-[28px] w-full bg-gradient-to-b from-[#5D400D] via-[#3E2C1F] to-[#221A30]" />
            <div className="font-poppins text-2xs absolute bottom-0 left-[18px] right-[18px] top-0 flex items-center justify-between leading-[19.2px]">
              <div className="text-yellow500 font-semibold">You get</div>

              <div className="flex items-center gap-1 self-stretch text-white">
                <div>{isAggregate ? 'Rewards' : 'VIP Points'}</div>
                {isAggregate ? <RewardIcon /> : <DiamondIcon />}
                <div className="text-green800">{vipPoints}</div>
              </div>
            </div>
          </div>
        )}
        <div className="pt-4">
          {isSingleContent && items?.[0] ? (
            <SingleItem data={items[0]} />
          ) : (
            <MultipleItems
              isAggregate={isAggregate}
              items={items}
              onItemClick={onItemClick}
              rewardItems={rewardItems}
              storeItemDescription={storeItemDescription}
            />
          )}
        </div>
      </div>
    </>
  );
};
